import { render } from "./modification.vue?vue&type=template&id=8bb666ae"
import script from "./modification.js?vue&type=script&lang=js&external"
export * from "./modification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__